<template>
    <div class="cdiv">
        <div class="header flex">
            <div>
                <el-image class="weiziiconst" :src="require('../assets/img/dingwei.png')" fit="cover"></el-image>
            </div>
            <div class="pleft">
                当前位置：<span>首页</span><span>>结算单</span>
            </div>
        </div>
        <div class="hc jsd-box">
            <el-tabs v-model="activeName">
                <el-tab-pane label="结算单列表" name="jsdTab">
                    <el-form size="small" :inline="true" ref="form" :model="jsdFrom" label-width="80px">
                        <el-form-item label="名称">
                            <el-col :span="24">
                                <el-input class="jsd-input" placeholder="请输入" v-model="jsdFrom.name" clearable></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="出发时间">
                            <el-col :span="24">
                                <el-date-picker
                                    class="jsd-input-date"
                                    type="date"
                                    placeholder="区间开始日期"
                                    v-model="jsdFrom.startDate"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                ></el-date-picker>
                            </el-col>
                        </el-form-item>
                        <el-form-item>
                            <el-col :span="24">
                                <el-date-picker
                                    class="jsd-input-date"
                                    type="date"
                                    placeholder="区间结束日期"
                                    v-model="jsdFrom.endDate"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                ></el-date-picker>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-col :span="24">
                                <el-select :clearable="true" class="jsd-input" v-model="jsdFrom.status" placeholder="请选择">
                                	<el-option v-for="item in Object.keys(jsdStatus)" :key="item" :label="jsdStatus[item]" :value="item"> </el-option>
                                </el-select>
                            </el-col>
                        </el-form-item>
                        <el-form-item>
                            <el-col :span="2">
                                <el-button class="querybtn" @click="searchJsd">搜索</el-button>
                            </el-col>
                        </el-form-item>
                    </el-form>
                    <div>
                        <el-table :data="jsdTableData" stripe
                            @row-click="handleJsdClickRow">
                            <el-table-column prop="id" label="ID" width="100"></el-table-column>
                            <el-table-column prop="name" label="结算单名称"></el-table-column>
                            <el-table-column prop="user_data" label="创建人" width="150">
                                <template #default="scope">
                                    {{scope.row.user_data?.nickname}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="create_time" label="创建时间" width="160"></el-table-column>
                            <el-table-column prop="status" label="状态" width="100">
                                <template #default="scope">
                                    {{jsdStatus[scope.row.status]}}
                                </template>
                            </el-table-column>
                            <el-table-column label="查看" width="100">
                                <template #default="scope">
                                    <el-button size="small" type="success">详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pager flex">
                        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
                        :total="pagination.total"></el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="创建结算单" name="addTab">
                    <el-form size="small" :inline="true" ref="form" :model="addFrom" label-width="80px">
                        <el-form-item label="票类型">
                            <el-col :span="24">
                                <el-select class="jsd-input" v-model="addFrom.ticket_type" placeholder="请选择">
                                	<el-option v-for="item in Object.keys(ticketTypes)" :key="item" :label="ticketTypes[item]" :value="item"> </el-option>
                                </el-select>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="流水号">
                            <el-col :span="24">
                                <el-input class="jsd-input" placeholder="请输入" v-model="addFrom.liushui_no" clearable></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="出发时间">
                            <el-col :span="24">
                                <el-date-picker
                                    class="jsd-input-date"
                                    type="date"
                                    placeholder="区间开始日期"
                                    v-model="addFrom.startDate"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                ></el-date-picker>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="至">
                            <el-col :span="24">
                                <el-date-picker
                                    class="jsd-input-date"
                                    type="date"
                                    placeholder="区间结束日期"
                                    v-model="addFrom.endDate"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                ></el-date-picker>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="班次">
                            <el-col :span="24">
                                <el-input class="jsd-input" placeholder="请输入" v-model="addFrom.train_number" clearable></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="出发">
                            <el-col :span="24">
                                <el-input class="jsd-input" placeholder="请输入" v-model="addFrom.departure_station" clearable></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="到达">
                            <el-col :span="24">
                                <el-input class="jsd-input" placeholder="请输入" v-model="addFrom.arrival_station" clearable></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="姓名">
                            <el-col :span="24">
                                <el-input class="jsd-input" placeholder="请输入" v-model="addFrom.xinming" clearable></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="证件号">
                            <el-col :span="24">
                                <el-input style="width: 370px;" placeholder="请输入" v-model="addFrom.card_id" clearable></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item>
                            <el-col :span="2">
                                <el-button class="querybtn" @click="searchAdd">搜索</el-button>
                            </el-col>
                        </el-form-item>
                    </el-form>
                    <div>
                        <el-table :data="addTableData" stripe
                            :row-class-name="tableRowClassName"
                            @selection-change="handleSelectionChange"
                            >
                            <el-table-column type="selection" width="45" fixed="left"></el-table-column>
                            <el-table-column prop="xinming" label="姓名" width="80"></el-table-column>
                            <el-table-column prop="card_id" label="证件号码" width="170"></el-table-column>
                            <el-table-column prop="send_date" label="出发时间" width="160"></el-table-column>
                            <el-table-column prop="status" label="行程" width="160">
                                <template #default="scope">
                                    {{scope.row.departure_station}} - {{scope.row.arrival_station}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="train_number" label="车次" width="100"></el-table-column>
                            <el-table-column prop="zuowei" label="坐席" width="70"></el-table-column>
                            <el-table-column prop="xiwei" label="位席" width="70"></el-table-column>
                            <el-table-column prop="order_money" label="价格" width="70"></el-table-column>
                            <el-table-column prop="liushui_no" label="流水号" width="170"></el-table-column>
                            <el-table-column prop="issue_tickets_status" label="出票状态" width="100">
                                <template #default="scope">
                                    {{issueTicketsStatus[`${scope.row.issue_tickets_status}`]}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="create-box">
                        <span style="width: 80px;">共: {{addCount}}张</span><span style="width: 100px;">¥ {{totalPrice}}</span>
                        <span class="flex" style="flex: 1;align-items: center">
                            结算单名称<el-input class="jsd-create-input" placeholder="请输入" v-model="addName" clearable></el-input>
                        </span>
                        <span>
                            <el-button class="savebtn" @click="saveJsd">创建结算单</el-button>
                        </span>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div class="copyright">
                工业和信息化部备案管理系统网站 豫B1-20080191-28
            </div>

        </div>
        <el-dialog
            title="结算单详情"
            :visible.sync="jsdDetailDialogVisible"
            width="1000px">
            <div>
                <div class="jsd-info">
                    <span class="item">ID: {{detail.id}}</span>
                    <span class="item">名称: {{detail.name}}</span>
                    <span class="item">{{detail.passenger?.length}}张</span>
                    <span class="item" :style="Number(detail.payable_j) < 0 ? 'color:red': ''">¥ {{detail.payable_j}}</span>
                    <span class="item">创建人: {{detail.user_data?.nickname}}</span>
                    <span class="item">{{detail.create_time}}</span>
                    <span class="item">状态: {{jsdStatus[detail.status]}}</span>
                </div>
                <div class="jsd-detail">
                    <el-table :data="detail.passenger" stripe>
                        <el-table-column prop="xinming" label="姓名" width="80"></el-table-column>
                        <el-table-column prop="card_id" label="证件号码" width="170"></el-table-column>
                        <el-table-column prop="send_date" label="出发时间" width="160"></el-table-column>
                        <el-table-column prop="status" label="行程" width="160">
                            <template #default="scope">
                                {{scope.row.departure_station}} - {{scope.row.arrival_station}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="train_number" label="车次" width="100"></el-table-column>
                        <el-table-column prop="zuowei" label="坐席" width="70"></el-table-column>
                        <el-table-column prop="xiwei" label="位席" width="70"></el-table-column>
                        <el-table-column prop="order_money" label="价格" width="70"></el-table-column>
                        <el-table-column prop="liushui_no" label="流水号" width="170"></el-table-column>
                    </el-table>
                </div>
                <div class="pay-list" v-show="detail.status != 0">
                    <span>支付信息</span>
                    <div class="item" v-show="detail.money_status == 1">
                        <span>余额支付：{{detail.money}}</span><span>{{detail.money_time}}</span>
                    </div>
                    <div class="item" v-show="detail.wx_status == 1">
                        <span>微信支付：{{detail.wx_money}}</span><span>{{detail.wx_time}}</span>
                    </div>
                    <div class="item" v-show="detail.ali_status == 1">
                        <span>支付宝支付：{{detail.ali_money}}</span><span>{{detail.ali_time}}</span>
                    </div>
                    <div class="item" v-show="detail.online_id > 0">
                        <span>线下支付({{detail.online_name}})：{{detail.online_money}}</span><span>{{detail.online_time}}</span>
                    </div>
                    <div class="pay-images" v-show="detail.online_images && detail.online_images.length > 0">
                        <div v-for="image in detail.online_images" :key="image">
                            <el-image
                                class="image-style"
                                :src="image"
                                @click="handlePictureCardPreview(image)"
                                fit="cover"></el-image>
                        </div>
                    </div>
                </div>
                <div class="audit-info" v-show="[4].includes(detail.status)">
                    <span>审核信息</span>
                    <div class="item">
                        <span>审核人: {{detail.check_user_name}}</span>
                        <span>{{detail.check_time}}</span>
                        <span>结果: {{jsdStatus[detail.status]}}</span>
                    </div>
                    <div>
                        {{detail.remark}}
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" v-show="[0, 1, 4].includes(detail.status)" @click="handleCancelPay(detail.id)">取消</el-button>
                <el-button v-show="[0, 1, 4].includes(detail.status)" class="defaultbtn" @click="handleSettlement(detail.id)">结算</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="支付"
            :visible.sync="jsdPayDialogVisible"
            :close-on-click-modal="false"
            :before-close="handleClose"
            width="700px">
            <div>
                <div class="pay-info">
                    <span class="item">
                        共: ¥{{detail.payable_j}}
                    </span>
                </div>
                <div class="pay-info" style="height: 60px;">
                    <span class="item">
                        <el-checkbox :disabled="detail.money > 0" v-model="isBalance" @change="(v) => changePayMethod('balance', v)">
                            余额支付: 
                        </el-checkbox>
                    </span>
                    <el-input-number v-show="detail.money == 0" :disabled="!isBalance || detail.money > 0" v-model="money.money" style="width:80px;" size="small" :min="0" :max="Math.min(Number(detail.payable_j), Number(gsDetail.gs_money))" :controls="false"></el-input-number>
                    <span v-show="detail.money > 0">{{detail.money}}</span>
                    <span class="item">可用余额: ¥{{gsDetail.gs_money}}</span>
                    <span style="margin-left: auto;">
                        <el-button v-show="detail.money == 0 && isBalance" class="defaultbtn" @click="handleWriteOffMoneyPay">余额支付</el-button>
                        <el-button v-show="detail.money > 0" type="danger" @click="handleWriteOffMoneyRefund">取消支付</el-button>
                    </span>
                </div>
                <div class="pay-info"> <!-- -->
                    <span class="item">
                        <el-checkbox 
                            :disabled="surplusVal == 0 || money.money > 0 || (isBalance && detail.money_status == 0)"
                            v-model="isOther" @change="changeOtherPay"><span style="margin-right: 15px;">剩余支付: ¥{{ surplusVal}}</span><span style="margin-left: 15px;">微信 / 支付宝 / 线下支付</span></el-checkbox>
                    </span>
                    <span style="margin-left: auto;">
                    </span>
                </div>
                <div v-show="isOther && !money.money">
                    <el-tabs v-model="payMethod" @tab-click="handleClickPay">
                        <el-tab-pane label="微信" name="wx">
                            <div>
                                <el-image
                                    class="image-style"
                                    :src="wxPayImage"
                                    @click="handlePictureCardPreview(wxPayImage)"
                                    fit="cover"></el-image>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="支付宝" name="ali">
                            <div class="image-style"
                                @click="handleOpenAliPay"
                                style="cursor: pointer;position: relative;border-width: 0">
                                <div class="flex click-alipay">
                                    <div class="text">点击支付</div>
                                </div>
                                <el-image
                                    class="ali-image-style"
                                    :src="require('../assets/img/alipay.png')"
                                    fit="cover"></el-image>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="线下支付" name="online">
                            <el-tabs v-model="offlineImageId" type="card">
                                <el-tab-pane :label="image.name" :name="`${image.id}`" v-for="image in onlinepayImage" :key="image.id">
                                    <el-image
                                        class="image-style"
                                        :src="image.code_image"
                                        @click="handlePictureCardPreview(image.code_image)"
                                        fit="cover"></el-image>
                                </el-tab-pane>
                            </el-tabs>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div style="border-top: 1px dashed #c0ccda;margin-top: 10px;padding-top: 10px;"
                    v-show="payMethod == 'online' && isOther && !money.money">
                    <span>上传凭证</span>
                    <div class="flex" style="column-gap: 10px;padding-top: 10px;">                            
                        <el-upload
                            :action="`${API_BASE_URL}/api/common/upload`"
                            list-type="picture-card"
                            :limit="4"
                            :file-list="fileList"
                            :on-remove="handleRemove"
                            :on-preview="handlePictureCardPreview"
                            :on-exceed="handleExceed"
                            :on-success="handleSuccess"
                            :auto-upload="true">
                            <i slot="default" class="el-icon-plus"></i>
                        </el-upload>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-show="isOther && !money.money && ['wx', 'ali'].includes(payMethod)" class="defaultbtn" @click="handlePayDone(true)">完成支付</el-button>
                <el-button v-show="isOther && !money.money && payMethod == 'online'" class="defaultbtn" @click="handlePay">确认支付</el-button>
                <el-button type="danger" @click="handleClose">关闭</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
    import ElButton from "element-ui/packages/button/src/button";
    import {
        writeOffIndex,
        writeWriteOffTicketList,
        writeOffAdd,
        writeOffPay,
        writeOffDetail,
        writeOffOnlinepay,
        gongsiDetail,
        writeOffMoneyPay,
        writeOffMoneyRefund,
        getUserInfo,
        writeOffCancel
    } from '../api/index';
    import Cookie from 'js-cookie';
    import { API_BASE_URL } from '../utils/config'
    export default {
        components: {
            ElButton
        },
        data () {
            return {
                API_BASE_URL: API_BASE_URL,
                activeName: 'jsdTab',
                jsdFrom: {
                    name: '',
                    startDate: '',
                    endDate: '',
                    status: ''
                },
                addFrom: {
                    ticket_type: '1',
                    liushui_no: '',
                    send_time: '',
                    startDate: '',
                    endDate: '',
                    train_number: '',
                    departure_station: '',
                    arrival_station: '',
                    xinming: '',
                    card_id: ''
                },
                addCount: 0,
                totalPrice: 0.0,
                ids: '',
                addName: '',
                addTicketType: '1',
                jsdTableData: [],
                addTableData: [],
                pagination: {
                    curpage: 1,
                    pagesize: 10,
                    total: 0,
                },
                userinfo: {},
                userInfoData: {},
                //0 未支付   1 部分支付  2 已完成   3 审核中  4  审核拒绝   5  已取消
                jsdStatus: {
                    '0': '未支付',
                    '1': '部分支付',
                    '2': '已完成',
                    '3': '审核中',
                    '4': '审核拒绝',
                    '5': '已取消',
                },
                ticketTypes: {
                    '1': '火车票',
                    '2': '飞机票',
                },
                payMethodMap: {
                    'wx': '微信支付',
                    'ali': '支付宝支付',
                    'money': '余额支付',
                    'online': '线下支付'
                },
                issueTicketsStatus: {
                    '0': '未出票',
                    '1': '已出票'
                },
                jsdDetailDialogVisible: false,
                detail: {},
                jsdPayDialogVisible: false,
                payMethod: 'online',
                fileList:[],
                dialogVisible: false,
                dialogImageUrl: '',
                gsDetail: {},
                money: {
                    money: 0,
                    wx_money: 0,
                    ali_money: 0,
                    offline_money: 0
                },
                isBalance: true,
                isWeixin: false,
                isAli: false,
                isOffline: false,
                isOther: false,
                onlinepayImage: [],
                wxPayImage: '',
                offlineImageId: '',
                payStatusTimerId: null
            }
        },
        computed: {
            surplusVal() {
                const surplusV = Number(this.detail.payable_j) - Number(this.money.money || 0) - Number(this.detail.money);
                return surplusV.toFixed(2);
            },
            maxMoney() {
                return Number(this.detail.payable_j) - Number(this.money.money || 0);
            },
            checkOtherPay() {
                return this.isOther && !this.money.money
            }
        },
        activated(){
            const ths = this;
            ths.userinfo =JSON.parse(Cookie.get('userinfo'));
            getUserInfo({user_id: ths.userinfo.id}).then(res => {
                const resData = res.data;
                if(resData.code == 1) {
                    ths.userInfoData = resData.data;
                    if(ths.userInfoData.is_fuzeren == 1) {
                        ths.getJsdList();
                    }
                }
            })
        },
        name: "jiesuandan-right",
        methods: {
            tableRowClassName({row, rowIndex}) {
                if (row.issue_tickets_status == 0) {
                    return 'unselectable';
                }
                return '';
            },
            handleClose() {
                const ths = this;
                ths.jsdPayDialogVisible = false;
                ths.resetData();
                ths.clearPayStatusTimer();
            },
            handleCancelPay(id) {
                const ths = this;
                this.$confirm("是否确认取消?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    writeOffCancel({id}).then(res => {
                        if(res.data.code == 1) {
                            ths.$message.success(res.data.msg);
                            ths.jsdDetailDialogVisible = false;
                            ths.jsdPayDialogVisible = false;
                            ths.searchJsd();
                            ths.resetData();
                        }
                        else {
                            ths.$message.warning(res.data.msg);
                        }
                    })
                })
                .catch(() => { });
            },
            handlePayDone(msg) {
                const ths = this;
                const write_id = ths.detail.id;
                ths.loadWriteOffDetail(write_id, (success, detail) => {
                    if(success) {
                        if(detail.status == 2 || (ths.payMethod == 'wx' && detail.wx_status == 1) 
                            || (ths.payMethod == 'ali' && detail.ali_status == 1) ) {
                            ths.$message.warning('支付成功');
                            ths.jsdPayDialogVisible = false;
                            ths.searchJsd();
                            ths.resetData();
                            ths.clearPayStatusTimer();
                        }
                        else {
                            if(msg)
                                ths.$message.warning('支付失败');
                        }
                    }
                    else {
                        if(msg)
                            ths.$message.warning('支付失败');
                    }
                })
            },
            clearPayStatusTimer() {
                clearInterval(this.payStatusTimerId);
                this.payStatusTimerId = null;
            },
            payStatusTimer() {
                const ths = this;
                if(ths.payStatusTimerId) {
                    ths.clearPayStatusTimer();
                }
                ths.payStatusTimerId = setInterval(() => {
                    ths.handlePayDone(false);
                }, 2000)
            },
            changeOtherPay(v) {
                // if(this.isBalance > 0) {
                //     this.$message.warning('有余额未支付');
                //     return;
                // }
                if(v) {
                    this.handleClickPay({name: 'wx'});
                }
            },
            handleCurrentChange(val) {
                this.pagination.curpage = val;
                this.getJsdList();
            },
            searchJsd() {
                this.pagination.curpage = 1;
                this.getJsdList();
            },
            async getJsdList() {
                const ths = this;
                const time = (ths.jsdFrom.startDate || ths.jsdFrom.endDate) 
                    ? `${ths.jsdFrom.startDate}~${ths.jsdFrom.endDate}`: '';
                const res = await writeOffIndex({
                    user_id: ths.userinfo.id,
                    page: ths.pagination.curpage,
                    limit: ths.pagination.pagesize,
                    name: ths.jsdFrom.name,
                    status: ths.jsdFrom.status,
                    time
                });
                this.jsdTableData = res.data.data.list;
                this.pagination.total = res.data.data.count;
            },
            searchAdd() {
                this.getAddList();
            },
            async getAddList() {
                const ths = this;
                const send_time = (ths.addFrom.startDate || ths.addFrom.endDate)
                    ? `${ths.addFrom.startDate}~${ths.addFrom.endDate}`: '';
                // 格式化发车时间
                ths.addFrom.send_time = send_time;
                const res = await writeWriteOffTicketList({
                    user_id: ths.userinfo.id,
                    ... ths.addFrom
                });
                this.addTableData = res.data.data?.list;
                ths.addTicketType = ths.addFrom.ticket_type;
            },
            saveJsd() {
                const ths = this;
                if(ths.addCount == 0) {
                    ths.$message.warning('请选择结算车票');
                    return;
                }
                if(!ths.addName) {
                    ths.$message.warning('请输入结算单名称');
                }
                writeOffAdd({
                    ids: ths.ids,
                    user_id: ths.userinfo.id,
                    ticket_type: ths.addTicketType,
                    name: ths.addName
                }).then(res => {
                    if(res.data.code == 1) {
                        ths.$message.success(res.data.msg);
                        ths.activeName = 'jsdTab';
                        ths.searchJsd();
                        ths.addCount = 0;
                        ths.ids = '';
                        ths.addName = '';
                        ths.addTicketType = '1';
                        ths.addFrom = {
                            ticket_type: '1',
                            liushui_no: '',
                            send_time: '',
                            startDate: '',
                            endDate: '',
                            train_number: '',
                            departure_station: '',
                            arrival_station: '',
                            xinming: '',
                            card_id: ''
                        };
                        ths.searchAdd();
                    }
                    else {
                        ths.$message.warning(res.data.msg);
                    }
                })
            },
            handleSelectionChange(rows) {
                this.addCount = rows.length;
                this.totalPrice = 0; 
                const idArr = [];
                for(let row of rows) {
                    this.totalPrice += Number(Number(row.order_money).toFixed(2));
                    idArr.push(row.topg_id);
                }
                this.ids = idArr.join(',');
            },
            loadWriteOffDetail(write_id, fn) {
                const ths = this;
                writeOffDetail({
                    write_id
                }).then(res => {
                    if(res.data.code == 1) {
                        ths.detail = res.data.data;
                        fn && fn(true, ths.detail);
                    }
                    else {
                        fn && fn(false, ths.detail);
                    }
                });
            },
            handleJsdClickRow(row, column, event) {
                const ths = this;
                ths.resetData();
                ths.loadWriteOffDetail(row.id);
                this.jsdDetailDialogVisible = true;
            },
            loadGsDetail() {
                const ths = this;
                gongsiDetail({user_id: ths.userinfo.id}).then(res => {
                    if(res.data.code == 1) 
                        ths.gsDetail = res.data.data;
                })
            },
            handleSettlement(write_id) {
                const ths = this;
                if(Number(ths.detail.payable_j) < 0) {
                    ths.$message.warning('请联系我们处理');
                    return;
                }
                ths.jsdDetailDialogVisible = false;
                ths.jsdPayDialogVisible = true;
                writeOffOnlinepay({}).then(res => {
                    if(res.data.code == 1) {
                        ths.onlinepayImage = res.data.data;
                        ths.offlineImageId = `${ths.onlinepayImage[0]?.id}`
                    }
                })
                ths.loadGsDetail()
            },            
            handleClickPay(tab, event) {
                const ths = this;
                const ticketType = ths.detail.ticket_type;
                const userId = ths.userinfo.id;
                const writeId = ths.detail.id;
                // 微信
                if(tab.name == 'wx') {
                    writeOffPay({
                        "user_id": userId,
                        "paymethod": 'wx',
                        "write_id": writeId
                    }).then(res => {
                        if(res.data.code == 1) {
                            ths.wxPayImage = res.data.data.image_url;
                        }
                        else {
                            ths.isOther = false;
                            ths.$message.warning(res.data.msg);
                        }
                    })
                    if(ths.payMethod == 'wx')
                        ths.payStatusTimer();
                }
                else if(tab.name == 'ali') {
                    ths.clearPayStatusTimer();
                }
                else if(tab.name == 'online') {
                    ths.clearPayStatusTimer();
                }
            },
            handleOpenAliPay() {
                const ths = this;
                const ticketType = ths.detail.ticket_type;
                const userId = ths.userinfo.id;
                const writeId = ths.detail.id;
                const url = `${API_BASE_URL}/api/write_off/pay?pay_method=ali&user_id=${userId}&write_id=${writeId}&ticketType=${ticketType}`
                window.open(url, '_blank');
                ths.payStatusTimer();
            },
            handlePay() {
                const ths = this;
                const paymethodArr = [];
                let onlineId = '';
                // 选择其他支付方式
                if(ths.isOther) {
                    paymethodArr.push(ths.payMethod);
                    if(ths.payMethod == 'online') {
                        if(!ths.offlineImageId) {
                            ths.$message.warning('请选择线下支付二维码');
                            return;
                        }
                        onlineId = ths.offlineImageId;
                        
                        if(ths.fileList.length == 0) {
                            ths.$message.warning('请上传支付凭证');
                            return;
                        }
                    }
                }
                if(paymethodArr.length == 0) {
                    ths.$message.warning('请选择支付方式');
                    return;
                }
                
                const fileList = ths.fileList.map(f => f.response.data.fullurl);
                const params = {
                    "write_id": ths.detail.id,
                    "user_id": ths.userinfo.id,
                    "paymethod": 'online',
                    "online_id": onlineId,
                    "online_images": fileList
                };
                writeOffPay(params).then(res => {
                    if(res.data.code == 1) {
                        ths.$message.success(res.data.msg);
                        ths.jsdPayDialogVisible = false;
                        ths.searchJsd();
                        ths.resetData();
                    }
                    else {
                        ths.$message.warning(res.data.msg);
                    }
                })
            },
            handleRemove(file, files) {
                this.fileList = files;
            },
            handleExceed() {
                this.$message.warning('超出最多可上传数量');
            },
            handleSuccess(res, file, files) {
                this.fileList = files;
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = typeof file == 'string' ? file: file.url;
                this.dialogVisible = true;
            },
            handleWriteOffMoneyPay() {
                const ths = this;
                const user_id = ths.userinfo.id;
                const write_id = ths.detail.id;
                const money = ths.money.money;
                if(!ths.money.money) {
                    ths.$message.warning('请输入余额');
                    return;
                }
                writeOffMoneyPay({
                    write_id,
                    user_id,
                    money
                }).then(res => {
                    if(res.data.code == 1) {
                        ths.$message.success(res.data.msg);
                        ths.loadWriteOffDetail(write_id);
                        ths.loadGsDetail();
                        ths.getJsdList();
                        ths.money.money = 0;
                    }
                    else {
                        ths.$message.warning(res.data.msg);
                    }
                })
            },
            handleWriteOffMoneyRefund() {
                const ths = this;
                const user_id = ths.userinfo.id;
                const write_id = ths.detail.id;
                writeOffMoneyRefund({
                    write_id,
                    user_id
                }).then(res => {
                    if(res.data.code == 1) {
                        ths.$message.success(res.data.msg);
                        ths.loadWriteOffDetail(write_id);
                        ths.loadGsDetail();
                    }
                    else {
                        ths.$message.warning(res.data.msg);
                    }
                })
            },
            changePayMethod(type, v) {
                const ths = this;
                if(type == 'balance') {
                    ths.money.money = 0;
                }
                if(type == 'wx') {
                    ths.money.wx_money = 0;
                }
                else if(type == 'ali') {
                    ths.money.ali_money = 0;
                }
                else if(type == 'offline') {
                    ths.money.offline_money = 0;
                }
            },
            resetData() {
                this.isOther = false;
                this.detail = {},
                this.payMethod = 'wx',
                this.fileList = [],
                this.dialogImageUrl = '',
                this.gsDetail = {},
                this.money = {
                    money: 0,
                    wx_money: 0,
                    ali_money: 0,
                    offline_money: 0
                },
                this.isBalance = true,
                this.isWeixin = false,
                this.isAli = false,
                this.isOffline = false,
                this.onlinepayImage = [],
                this.wxPayImage = '';
                this.offlineImageId = '';
            }
        }
    }
</script>

<style scoped>
    ::v-deep .unselectable .el-checkbox {
      display: none;
    }
    .click-alipay {
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 10;
    }
    .click-alipay .text {        
        background-color: #42B134;
        color: #fff;
        font-size: 12px;
        padding: 4px 8px;
        border-radius: 3px;
    }
    .image-style {
        width: 148px;
        height: 148px;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
    }
    .audit-info,
    .pay-list {
        padding: 10px 0 0;
    }
    .audit-info .item,
    .pay-list .item {
        display: flex;
        column-gap: 20px;
        padding: 5px 0;
    }
    .pay-list .pay-images {
        padding: 10px 0;
        display: flex;
        column-gap: 15px;
    }
    .pay-info,
    .jsd-info {
        display: flex;
        column-gap: 20px;
        padding: 5px 0;
        align-items: center;
    }
    .jsd-info .item {
        display: flex;
        align-items: center;
    }
    .create-box {
        display: flex;
        justify-content: space-between;
        padding-top: 20px;
        font-size: 14px;
        color: #606266;
        align-items: center;
    }
    .jsd-create-input {
        width: 300px;
        margin-left: 5px;
    }
    ::v-deep .jsd-create-input .el-input__inner {
        width: 300px;
        line-height: 32px;
        height: 32px;
    }
    .defaultbtn {
        background-color:#42B134;
        color: #fff;
    }
    .savebtn {
        line-height: 32px;
        height: 32px;
        padding: 0 10px;
        background-color:#42B134;
        color: #fff;
    }
    .jsd-box .jsd-input,
    .jsd-box .jsd-input-date {
        width: 140px;
    }
    .weiziiconst{
        width:24px;
        height:24px;
    }
    .pager {
        margin-top:5vh;
        margin-left:0vw;
        display: flex;
        justify-content: center;
    }
    .querybtn{
        background-color:#42B134;
        color:#FFFFFF;
        border-radius: 5px;
        width: 100px;
    }
    .header{
        font-size:12px;
    }
    .flex{
        display:flex;
    }
    .pleft{
        margin-left:0.5vw;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        font-size: 16px;
        color: #000000;
    }
    .hc{
        margin-top:2vh;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
    }
    .copyright{
        font-size:12px;
        text-align: center;
        margin-top:5vh;
        color:#B6B6B6;
    }
    button:hover {background-color: #42B134;color:#FFFFFF;}
</style>